import { render, staticRenderFns } from "./MASalden.vue?vue&type=template&id=c4728590"
import script from "./MASalden.vue?vue&type=script&lang=ts"
export * from "./MASalden.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports